@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(419_996_118)
internal val Res.drawable.plug_charging: DrawableResource by lazy {
      DrawableResource("drawable:plug_charging", setOf(
        ResourceItem(setOf(), "${MD}drawable/plug_charging.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-824_806_537)
internal val Res.drawable.plugs: DrawableResource by lazy {
      DrawableResource("drawable:plugs", setOf(
        ResourceItem(setOf(), "${MD}drawable/plugs.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(236_945_972)
internal val Res.drawable.plugs_connected: DrawableResource by lazy {
      DrawableResource("drawable:plugs_connected", setOf(
        ResourceItem(setOf(), "${MD}drawable/plugs_connected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(889_606_656)
internal val Res.drawable.plus: DrawableResource by lazy {
      DrawableResource("drawable:plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-834_642_294)
internal val Res.drawable.plus_circle: DrawableResource by lazy {
      DrawableResource("drawable:plus_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_171_016_231)
internal val Res.drawable.plus_minus: DrawableResource by lazy {
      DrawableResource("drawable:plus_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-895_605_812)
internal val Res.drawable.poker_chip: DrawableResource by lazy {
      DrawableResource("drawable:poker_chip", setOf(
        ResourceItem(setOf(), "${MD}drawable/poker_chip.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(992_737_663)
internal val Res.drawable.polygon: DrawableResource by lazy {
      DrawableResource("drawable:polygon", setOf(
        ResourceItem(setOf(), "${MD}drawable/polygon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_585_984_258)
internal val Res.drawable.popcorn: DrawableResource by lazy {
      DrawableResource("drawable:popcorn", setOf(
        ResourceItem(setOf(), "${MD}drawable/popcorn.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_424_109_877)
internal val Res.drawable.popsicle: DrawableResource by lazy {
      DrawableResource("drawable:popsicle", setOf(
        ResourceItem(setOf(), "${MD}drawable/popsicle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(202_827_684)
internal val Res.drawable.potted_plant: DrawableResource by lazy {
      DrawableResource("drawable:potted_plant", setOf(
        ResourceItem(setOf(), "${MD}drawable/potted_plant.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(993_880_075)
internal val Res.drawable.power: DrawableResource by lazy {
      DrawableResource("drawable:power", setOf(
        ResourceItem(setOf(), "${MD}drawable/power.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-306_743_983)
internal val Res.drawable.prescription: DrawableResource by lazy {
      DrawableResource("drawable:prescription", setOf(
        ResourceItem(setOf(), "${MD}drawable/prescription.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-85_185_570)
internal val Res.drawable.presentation: DrawableResource by lazy {
      DrawableResource("drawable:presentation", setOf(
        ResourceItem(setOf(), "${MD}drawable/presentation.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_502_309_199)
internal val Res.drawable.presentation_chart: DrawableResource by lazy {
      DrawableResource("drawable:presentation_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/presentation_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(986_806_548)
internal val Res.drawable.printer: DrawableResource by lazy {
      DrawableResource("drawable:printer", setOf(
        ResourceItem(setOf(), "${MD}drawable/printer.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_814_206_436)
internal val Res.drawable.prohibit: DrawableResource by lazy {
      DrawableResource("drawable:prohibit", setOf(
        ResourceItem(setOf(), "${MD}drawable/prohibit.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_550_027_088)
internal val Res.drawable.prohibit_inset: DrawableResource by lazy {
      DrawableResource("drawable:prohibit_inset", setOf(
        ResourceItem(setOf(), "${MD}drawable/prohibit_inset.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_121_345_067)
internal val Res.drawable.projector_screen: DrawableResource by lazy {
      DrawableResource("drawable:projector_screen", setOf(
        ResourceItem(setOf(), "${MD}drawable/projector_screen.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_050_703_980)
internal val Res.drawable.projector_screen_chart: DrawableResource by lazy {
      DrawableResource("drawable:projector_screen_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/projector_screen_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-30_188_876)
internal val Res.drawable.pulse: DrawableResource by lazy {
      DrawableResource("drawable:pulse", setOf(
        ResourceItem(setOf(), "${MD}drawable/pulse.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-263_234_252)
internal val Res.drawable.push: DrawableResource by lazy {
      DrawableResource("drawable:push", setOf(
        ResourceItem(setOf(), "${MD}drawable/push.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-313_331_764)
internal val Res.drawable.push_pin_simple: DrawableResource by lazy {
      DrawableResource("drawable:push_pin_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/push_pin_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_057_199_850)
internal val Res.drawable.push_pin_simple_slash: DrawableResource by lazy {
      DrawableResource("drawable:push_pin_simple_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/push_pin_simple_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-713_283_839)
internal val Res.drawable.push_pin_slash: DrawableResource by lazy {
      DrawableResource("drawable:push_pin_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/push_pin_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-255_183_421)
internal val Res.drawable.puzzle_piece: DrawableResource by lazy {
      DrawableResource("drawable:puzzle_piece", setOf(
        ResourceItem(setOf(), "${MD}drawable/puzzle_piece.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_256_502_393)
internal val Res.drawable.qr_code: DrawableResource by lazy {
      DrawableResource("drawable:qr_code", setOf(
        ResourceItem(setOf(), "${MD}drawable/qr_code.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_042_799_273)
internal val Res.drawable.question: DrawableResource by lazy {
      DrawableResource("drawable:question", setOf(
        ResourceItem(setOf(), "${MD}drawable/question.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(635_720_329)
internal val Res.drawable.question_mark: DrawableResource by lazy {
      DrawableResource("drawable:question_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/question_mark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_144_575_486)
internal val Res.drawable.queue: DrawableResource by lazy {
      DrawableResource("drawable:queue", setOf(
        ResourceItem(setOf(), "${MD}drawable/queue.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-560_570_597)
internal val Res.drawable.quotes: DrawableResource by lazy {
      DrawableResource("drawable:quotes", setOf(
        ResourceItem(setOf(), "${MD}drawable/quotes.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(427_769_151)
internal val Res.drawable.rabbit: DrawableResource by lazy {
      DrawableResource("drawable:rabbit", setOf(
        ResourceItem(setOf(), "${MD}drawable/rabbit.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_951_089_573)
internal val Res.drawable.racquet: DrawableResource by lazy {
      DrawableResource("drawable:racquet", setOf(
        ResourceItem(setOf(), "${MD}drawable/racquet.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_752_154)
internal val Res.drawable.radical: DrawableResource by lazy {
      DrawableResource("drawable:radical", setOf(
        ResourceItem(setOf(), "${MD}drawable/radical.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_442_936_395)
internal val Res.drawable.radio: DrawableResource by lazy {
      DrawableResource("drawable:radio", setOf(
        ResourceItem(setOf(), "${MD}drawable/radio.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_946_901_939)
internal val Res.drawable.radio_button: DrawableResource by lazy {
      DrawableResource("drawable:radio_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/radio_button.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_407_103_255)
internal val Res.drawable.radioactive: DrawableResource by lazy {
      DrawableResource("drawable:radioactive", setOf(
        ResourceItem(setOf(), "${MD}drawable/radioactive.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_674_779_937)
internal val Res.drawable.rainbow: DrawableResource by lazy {
      DrawableResource("drawable:rainbow", setOf(
        ResourceItem(setOf(), "${MD}drawable/rainbow.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_886_914_051)
internal val Res.drawable.rainbow_cloud: DrawableResource by lazy {
      DrawableResource("drawable:rainbow_cloud", setOf(
        ResourceItem(setOf(), "${MD}drawable/rainbow_cloud.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_167_399_445)
internal val Res.drawable.ranking: DrawableResource by lazy {
      DrawableResource("drawable:ranking", setOf(
        ResourceItem(setOf(), "${MD}drawable/ranking.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_730_570_951)
internal val Res.drawable.read_cv_logo: DrawableResource by lazy {
      DrawableResource("drawable:read_cv_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/read_cv_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-476_422_448)
internal val Res.drawable.receipt: DrawableResource by lazy {
      DrawableResource("drawable:receipt", setOf(
        ResourceItem(setOf(), "${MD}drawable/receipt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-415_193_664)
internal val Res.drawable.receipt_x: DrawableResource by lazy {
      DrawableResource("drawable:receipt_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/receipt_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(734_716_203)
internal val Res.drawable.record: DrawableResource by lazy {
      DrawableResource("drawable:record", setOf(
        ResourceItem(setOf(), "${MD}drawable/record.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(561_566_680)
internal val Res.drawable.rectangle: DrawableResource by lazy {
      DrawableResource("drawable:rectangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/rectangle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_154_996_758)
internal val Res.drawable.rectangle_dashed: DrawableResource by lazy {
      DrawableResource("drawable:rectangle_dashed", setOf(
        ResourceItem(setOf(), "${MD}drawable/rectangle_dashed.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_844_262_677)
internal val Res.drawable.recycle: DrawableResource by lazy {
      DrawableResource("drawable:recycle", setOf(
        ResourceItem(setOf(), "${MD}drawable/recycle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-306_423_611)
internal val Res.drawable.reddit_logo: DrawableResource by lazy {
      DrawableResource("drawable:reddit_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/reddit_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-346_264_004)
internal val Res.drawable.repeat: DrawableResource by lazy {
      DrawableResource("drawable:repeat", setOf(
        ResourceItem(setOf(), "${MD}drawable/repeat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_719_765_643)
internal val Res.drawable.repeat_once: DrawableResource by lazy {
      DrawableResource("drawable:repeat_once", setOf(
        ResourceItem(setOf(), "${MD}drawable/repeat_once.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_473_814_780)
internal val Res.drawable.replit_logo: DrawableResource by lazy {
      DrawableResource("drawable:replit_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/replit_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_156_602_753)
internal val Res.drawable.resize: DrawableResource by lazy {
      DrawableResource("drawable:resize", setOf(
        ResourceItem(setOf(), "${MD}drawable/resize.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_612_962_252)
internal val Res.drawable.resource_package: DrawableResource by lazy {
      DrawableResource("drawable:resource_package", setOf(
        ResourceItem(setOf(), "${MD}drawable/resource_package.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_556_390)
internal val Res.drawable.rewind: DrawableResource by lazy {
      DrawableResource("drawable:rewind", setOf(
        ResourceItem(setOf(), "${MD}drawable/rewind.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(136_891_628)
internal val Res.drawable.rewind_circle: DrawableResource by lazy {
      DrawableResource("drawable:rewind_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/rewind_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(432_729_807)
internal val Res.drawable.road_horizon: DrawableResource by lazy {
      DrawableResource("drawable:road_horizon", setOf(
        ResourceItem(setOf(), "${MD}drawable/road_horizon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_189_043_418)
internal val Res.drawable.robot: DrawableResource by lazy {
      DrawableResource("drawable:robot", setOf(
        ResourceItem(setOf(), "${MD}drawable/robot.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(372_951_595)
internal val Res.drawable.rocket: DrawableResource by lazy {
      DrawableResource("drawable:rocket", setOf(
        ResourceItem(setOf(), "${MD}drawable/rocket.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_435_441_811)
internal val Res.drawable.rocket_launch: DrawableResource by lazy {
      DrawableResource("drawable:rocket_launch", setOf(
        ResourceItem(setOf(), "${MD}drawable/rocket_launch.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_946_780_926)
internal val Res.drawable.rows: DrawableResource by lazy {
      DrawableResource("drawable:rows", setOf(
        ResourceItem(setOf(), "${MD}drawable/rows.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_145_563_192)
internal val Res.drawable.rows_plus_bottom: DrawableResource by lazy {
      DrawableResource("drawable:rows_plus_bottom", setOf(
        ResourceItem(setOf(), "${MD}drawable/rows_plus_bottom.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_079_059_014)
internal val Res.drawable.rows_plus_top: DrawableResource by lazy {
      DrawableResource("drawable:rows_plus_top", setOf(
        ResourceItem(setOf(), "${MD}drawable/rows_plus_top.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-40_666_242)
internal val Res.drawable.rss: DrawableResource by lazy {
      DrawableResource("drawable:rss", setOf(
        ResourceItem(setOf(), "${MD}drawable/rss.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_072_953_559)
internal val Res.drawable.rss_simple: DrawableResource by lazy {
      DrawableResource("drawable:rss_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/rss_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(808_350_536)
internal val Res.drawable.rug: DrawableResource by lazy {
      DrawableResource("drawable:rug", setOf(
        ResourceItem(setOf(), "${MD}drawable/rug.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(480_863_845)
internal val Res.drawable.ruler: DrawableResource by lazy {
      DrawableResource("drawable:ruler", setOf(
        ResourceItem(setOf(), "${MD}drawable/ruler.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_045_656_118)
internal val Res.drawable.sailboat: DrawableResource by lazy {
      DrawableResource("drawable:sailboat", setOf(
        ResourceItem(setOf(), "${MD}drawable/sailboat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_582_082_468)
internal val Res.drawable.scales: DrawableResource by lazy {
      DrawableResource("drawable:scales", setOf(
        ResourceItem(setOf(), "${MD}drawable/scales.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_258_742_226)
internal val Res.drawable.scan: DrawableResource by lazy {
      DrawableResource("drawable:scan", setOf(
        ResourceItem(setOf(), "${MD}drawable/scan.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_050_447_876)
internal val Res.drawable.scan_smiley: DrawableResource by lazy {
      DrawableResource("drawable:scan_smiley", setOf(
        ResourceItem(setOf(), "${MD}drawable/scan_smiley.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-483_251_786)
internal val Res.drawable.scissors: DrawableResource by lazy {
      DrawableResource("drawable:scissors", setOf(
        ResourceItem(setOf(), "${MD}drawable/scissors.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_996_999_960)
internal val Res.drawable.scooter: DrawableResource by lazy {
      DrawableResource("drawable:scooter", setOf(
        ResourceItem(setOf(), "${MD}drawable/scooter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_690_494_540)
internal val Res.drawable.screencast: DrawableResource by lazy {
      DrawableResource("drawable:screencast", setOf(
        ResourceItem(setOf(), "${MD}drawable/screencast.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_636_070_814)
internal val Res.drawable.screwdriver: DrawableResource by lazy {
      DrawableResource("drawable:screwdriver", setOf(
        ResourceItem(setOf(), "${MD}drawable/screwdriver.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-439_429_142)
internal val Res.drawable.scribble: DrawableResource by lazy {
      DrawableResource("drawable:scribble", setOf(
        ResourceItem(setOf(), "${MD}drawable/scribble.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_466_440_331)
internal val Res.drawable.scribble_loop: DrawableResource by lazy {
      DrawableResource("drawable:scribble_loop", setOf(
        ResourceItem(setOf(), "${MD}drawable/scribble_loop.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_582_949_585)
internal val Res.drawable.scroll: DrawableResource by lazy {
      DrawableResource("drawable:scroll", setOf(
        ResourceItem(setOf(), "${MD}drawable/scroll.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-434_790_650)
internal val Res.drawable.seal: DrawableResource by lazy {
      DrawableResource("drawable:seal", setOf(
        ResourceItem(setOf(), "${MD}drawable/seal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_989_855_507)
internal val Res.drawable.seal_check: DrawableResource by lazy {
      DrawableResource("drawable:seal_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/seal_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(695_876_204)
internal val Res.drawable.seal_percent: DrawableResource by lazy {
      DrawableResource("drawable:seal_percent", setOf(
        ResourceItem(setOf(), "${MD}drawable/seal_percent.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_123_827_807)
internal val Res.drawable.seal_question: DrawableResource by lazy {
      DrawableResource("drawable:seal_question", setOf(
        ResourceItem(setOf(), "${MD}drawable/seal_question.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_417_300_104)
internal val Res.drawable.seal_warning: DrawableResource by lazy {
      DrawableResource("drawable:seal_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/seal_warning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-423_927_113)
internal val Res.drawable.seat: DrawableResource by lazy {
      DrawableResource("drawable:seat", setOf(
        ResourceItem(setOf(), "${MD}drawable/seat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(607_503_254)
internal val Res.drawable.seatbelt: DrawableResource by lazy {
      DrawableResource("drawable:seatbelt", setOf(
        ResourceItem(setOf(), "${MD}drawable/seatbelt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_198_305_773)
internal val Res.drawable.security_camera: DrawableResource by lazy {
      DrawableResource("drawable:security_camera", setOf(
        ResourceItem(setOf(), "${MD}drawable/security_camera.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-583_832_730)
internal val Res.drawable.selection: DrawableResource by lazy {
      DrawableResource("drawable:selection", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-377_759_273)
internal val Res.drawable.selection_background: DrawableResource by lazy {
      DrawableResource("drawable:selection_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection_background.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_224_107_627)
internal val Res.drawable.selection_foreground: DrawableResource by lazy {
      DrawableResource("drawable:selection_foreground", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection_foreground.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_933_268_831)
internal val Res.drawable.selection_inverse: DrawableResource by lazy {
      DrawableResource("drawable:selection_inverse", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection_inverse.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_076_422_681)
internal val Res.drawable.selection_plus: DrawableResource by lazy {
      DrawableResource("drawable:selection_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(970_177_238)
internal val Res.drawable.selection_slash: DrawableResource by lazy {
      DrawableResource("drawable:selection_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/selection_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_704_138_411)
internal val Res.drawable.shapes: DrawableResource by lazy {
      DrawableResource("drawable:shapes", setOf(
        ResourceItem(setOf(), "${MD}drawable/shapes.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-828_593_641)
internal val Res.drawable.share: DrawableResource by lazy {
      DrawableResource("drawable:share", setOf(
        ResourceItem(setOf(), "${MD}drawable/share.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-418_517_997)
internal val Res.drawable.share_network: DrawableResource by lazy {
      DrawableResource("drawable:share_network", setOf(
        ResourceItem(setOf(), "${MD}drawable/share_network.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_114_467_633)
internal val Res.drawable.shield: DrawableResource by lazy {
      DrawableResource("drawable:shield", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_543_026_626)
internal val Res.drawable.shield_check: DrawableResource by lazy {
      DrawableResource("drawable:shield_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(260_162_623)
internal val Res.drawable.shield_checkered: DrawableResource by lazy {
      DrawableResource("drawable:shield_checkered", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield_checkered.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-280_940_193)
internal val Res.drawable.shield_chevron: DrawableResource by lazy {
      DrawableResource("drawable:shield_chevron", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield_chevron.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_670_536_955)
internal val Res.drawable.shield_plus: DrawableResource by lazy {
      DrawableResource("drawable:shield_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_780_727_408)
internal val Res.drawable.shield_slash: DrawableResource by lazy {
      DrawableResource("drawable:shield_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/shield_slash.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable9Resources(map: MutableMap<String, DrawableResource>) {
  map.put("plug_charging", Res.drawable.plug_charging)
  map.put("plugs", Res.drawable.plugs)
  map.put("plugs_connected", Res.drawable.plugs_connected)
  map.put("plus", Res.drawable.plus)
  map.put("plus_circle", Res.drawable.plus_circle)
  map.put("plus_minus", Res.drawable.plus_minus)
  map.put("poker_chip", Res.drawable.poker_chip)
  map.put("polygon", Res.drawable.polygon)
  map.put("popcorn", Res.drawable.popcorn)
  map.put("popsicle", Res.drawable.popsicle)
  map.put("potted_plant", Res.drawable.potted_plant)
  map.put("power", Res.drawable.power)
  map.put("prescription", Res.drawable.prescription)
  map.put("presentation", Res.drawable.presentation)
  map.put("presentation_chart", Res.drawable.presentation_chart)
  map.put("printer", Res.drawable.printer)
  map.put("prohibit", Res.drawable.prohibit)
  map.put("prohibit_inset", Res.drawable.prohibit_inset)
  map.put("projector_screen", Res.drawable.projector_screen)
  map.put("projector_screen_chart", Res.drawable.projector_screen_chart)
  map.put("pulse", Res.drawable.pulse)
  map.put("push", Res.drawable.push)
  map.put("push_pin_simple", Res.drawable.push_pin_simple)
  map.put("push_pin_simple_slash", Res.drawable.push_pin_simple_slash)
  map.put("push_pin_slash", Res.drawable.push_pin_slash)
  map.put("puzzle_piece", Res.drawable.puzzle_piece)
  map.put("qr_code", Res.drawable.qr_code)
  map.put("question", Res.drawable.question)
  map.put("question_mark", Res.drawable.question_mark)
  map.put("queue", Res.drawable.queue)
  map.put("quotes", Res.drawable.quotes)
  map.put("rabbit", Res.drawable.rabbit)
  map.put("racquet", Res.drawable.racquet)
  map.put("radical", Res.drawable.radical)
  map.put("radio", Res.drawable.radio)
  map.put("radio_button", Res.drawable.radio_button)
  map.put("radioactive", Res.drawable.radioactive)
  map.put("rainbow", Res.drawable.rainbow)
  map.put("rainbow_cloud", Res.drawable.rainbow_cloud)
  map.put("ranking", Res.drawable.ranking)
  map.put("read_cv_logo", Res.drawable.read_cv_logo)
  map.put("receipt", Res.drawable.receipt)
  map.put("receipt_x", Res.drawable.receipt_x)
  map.put("record", Res.drawable.record)
  map.put("rectangle", Res.drawable.rectangle)
  map.put("rectangle_dashed", Res.drawable.rectangle_dashed)
  map.put("recycle", Res.drawable.recycle)
  map.put("reddit_logo", Res.drawable.reddit_logo)
  map.put("repeat", Res.drawable.repeat)
  map.put("repeat_once", Res.drawable.repeat_once)
  map.put("replit_logo", Res.drawable.replit_logo)
  map.put("resize", Res.drawable.resize)
  map.put("resource_package", Res.drawable.resource_package)
  map.put("rewind", Res.drawable.rewind)
  map.put("rewind_circle", Res.drawable.rewind_circle)
  map.put("road_horizon", Res.drawable.road_horizon)
  map.put("robot", Res.drawable.robot)
  map.put("rocket", Res.drawable.rocket)
  map.put("rocket_launch", Res.drawable.rocket_launch)
  map.put("rows", Res.drawable.rows)
  map.put("rows_plus_bottom", Res.drawable.rows_plus_bottom)
  map.put("rows_plus_top", Res.drawable.rows_plus_top)
  map.put("rss", Res.drawable.rss)
  map.put("rss_simple", Res.drawable.rss_simple)
  map.put("rug", Res.drawable.rug)
  map.put("ruler", Res.drawable.ruler)
  map.put("sailboat", Res.drawable.sailboat)
  map.put("scales", Res.drawable.scales)
  map.put("scan", Res.drawable.scan)
  map.put("scan_smiley", Res.drawable.scan_smiley)
  map.put("scissors", Res.drawable.scissors)
  map.put("scooter", Res.drawable.scooter)
  map.put("screencast", Res.drawable.screencast)
  map.put("screwdriver", Res.drawable.screwdriver)
  map.put("scribble", Res.drawable.scribble)
  map.put("scribble_loop", Res.drawable.scribble_loop)
  map.put("scroll", Res.drawable.scroll)
  map.put("seal", Res.drawable.seal)
  map.put("seal_check", Res.drawable.seal_check)
  map.put("seal_percent", Res.drawable.seal_percent)
  map.put("seal_question", Res.drawable.seal_question)
  map.put("seal_warning", Res.drawable.seal_warning)
  map.put("seat", Res.drawable.seat)
  map.put("seatbelt", Res.drawable.seatbelt)
  map.put("security_camera", Res.drawable.security_camera)
  map.put("selection", Res.drawable.selection)
  map.put("selection_background", Res.drawable.selection_background)
  map.put("selection_foreground", Res.drawable.selection_foreground)
  map.put("selection_inverse", Res.drawable.selection_inverse)
  map.put("selection_plus", Res.drawable.selection_plus)
  map.put("selection_slash", Res.drawable.selection_slash)
  map.put("shapes", Res.drawable.shapes)
  map.put("share", Res.drawable.share)
  map.put("share_network", Res.drawable.share_network)
  map.put("shield", Res.drawable.shield)
  map.put("shield_check", Res.drawable.shield_check)
  map.put("shield_checkered", Res.drawable.shield_checkered)
  map.put("shield_chevron", Res.drawable.shield_chevron)
  map.put("shield_plus", Res.drawable.shield_plus)
  map.put("shield_slash", Res.drawable.shield_slash)
}
